module.exports = __webpack_public_path__ + "img/dne-backoffice.186dc28a.svg";